import { toNumber } from "lodash";

export const minMax = (num: number, min: number, max: number) => {
  return Math.min(Math.max(toNumber(num), min), max);
};

export const MathUtils = Object.freeze({
  minMax,
});
